import { render } from "./ProGuardados.vue?vue&type=template&id=ad82e3bc&scoped=true"
import script from "./ProGuardados.vue?vue&type=script&lang=js"
export * from "./ProGuardados.vue?vue&type=script&lang=js"

import "./ProGuardados.vue?vue&type=style&index=0&id=ad82e3bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ad82e3bc"

export default script